import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';

import { UnsplashFooterProps } from './types';

const EXTERNAL_UNSPLASH_URL = 'https://unsplash.com/?utm_source=lyearn&utm_medium=referral';

const UnsplashFooter: React.FC<UnsplashFooterProps> = (props) => {
  const { authorName, authorLink } = props;
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" className="mb-32 w-full me-40" justifyContent="end">
      <Typography color="text-text-white" variant="body-short-03">
        {t('Common:Design.PhotoBy')}{' '}
        <a className="underline" href={authorLink} rel="noreferrer" target="_blank">
          {authorName}
        </a>{' '}
        {t('Common:On')}{' '}
        <a className="underline" href={EXTERNAL_UNSPLASH_URL} rel="noreferrer" target="_blank">
          {t('Common:Design.Unsplash')}
        </a>
      </Typography>
    </Stack>
  );
};

export default UnsplashFooter;
